// extracted by mini-css-extract-plugin
module.exports = {"overlayError":"styles_overlayError__1MzQk","error":"styles_error__2gt_G"};